///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="processEditor-module.ts"/>
module ProcessEditor {
    "use strict";

    // Used for task,return and foreachStart nodes -- Watches the validity of the node's popover form, and adds or removes invalid indicator
    export function nodeValidityDisplayUpdaterDirective($timeout): ng.IDirective {
        return {
            restrict: "A",
            link: (scope: IPopoverFormScope, element, attributes: ng.IAttributes) => {
                scope.$watch(() => {
                     return scope.PopoverForm.$pristine || scope.PopoverForm.$valid;
                },(valid, oldValue) => {
                    if (valid) {
                        element.removeClass("process-node-invalid");
                    } else {
                        element.addClass("process-node-invalid");
                    }
                    });
                var validationHandler = (event) => {
                    var formScope = <IPopoverFormScope>event.currentScope;
                    $timeout(() => {
                            formScope.PopoverForm.$setDirty(); // for tasks sets task box red if form fields are invalid
                            formScope.showValidationErrors = true; // shows errors for input fields which are not valid
                    });
                };
                scope.$on("hide.editor.frends ",validationHandler);
                scope.$on("validate.trigger.frends", validationHandler);
            }
        }
    }
    app.directive("nodeValidityDisplayUpdater", ["$timeout", nodeValidityDisplayUpdaterDirective]);

    interface IPopoverFormScope extends IValidationScope {
        PopoverForm : ng.IFormController;
    }

    export interface IUniqueTaskNameValidatorScope extends ng.IScope {
        uniqueTaskNameValidator: Node;
    }
    // Watches changes to task node names, and propagates validation to all tasks in the entire process on change.
    export function uniqueTaskNameValidatorDirective($rootScope, processService, recursiveNodeCollector): ng.IDirective {
        return {
            restrict: "A",
            require: "ngModel",
            scope: false,
            link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel: ng.INgModelController) => {
                var doValidation = () => {
                    var currentNode = (<any>scope.$parent).node;

                    var allTasks = recursiveNodeCollector.getTasks(processService.currentProcess.rootScope);
                    allTasks = _.filter(allTasks, (taskNode: any) => {
                        return taskNode.nodeId !== currentNode.nodeId && taskNode.name;
                    });

                    var blackList = _.map(allTasks,(task: TaskNode) => {
                        return task.name.toLowerCase();
                    });

                    // ngModel.$validate.unique cannot be used here, because doValidation() needs to be fired for every task.
                    // Also, ngModel.$validate sets the value of the input to undefined when the field is emptied, which is not very nice behavior
                    var valid = blackList.indexOf(element.val().toLowerCase()) === -1;
                    ngModel.$setValidity("unique", valid);
                };

                // When the name of one task changes, trigger validation on all other tasks in the process.
                element.on("keyup",() => {
                    scope.$apply(() => {
                        $rootScope.$broadcast("validatetaskname");
                    });
                });

                // Listen for validation trigger. doValidation called when any task gets its name updated.
                scope.$on("validatetaskname", doValidation);
            }
        }
    }
    app.directive("uniqueTaskNameValidator", ["$rootScope", "ProcessService", "RecursiveNodeCollector", uniqueTaskNameValidatorDirective]);


    /**
     * The condition label element is drawn by jsPlumb. In order to give it a red border when the popover is invalid, this directive watches
     *  the validity of the expression input field, and sets the class to the label. Assumes that the ID of the label is the conditionID.
     */
    export function conditionExpressionValidatorDirective(): ng.IDirective {
        return {
            restrict: "A",
            require: "ngModel",
            scope: {
                conditionExpressionValidator: "="
            },
            link: (scope: ConditionExpressionValidatorScope, element, attributes, ngModel: ng.INgModelController) => {
                var validate = (forceDirty) => {
                    if (forceDirty) {
                        ngModel.$setDirty();
                    }

                    // the labels id is set in ProcessEditor.ConnectionDrawingService.updateLabels
                    var conditionLabel = $(`#label_${scope.conditionExpressionValidator}`);
                    if (ngModel.$invalid && ngModel.$dirty) {
                        conditionLabel.addClass("invalid").attr("title", FRENDS.Localizations.Validation_ConditionExpressionsRequired);
                    } else {
                        conditionLabel.removeClass("invalid").attr("title", "");
                    }
                };

                // When the user changes the expression value, and it changes validity state
                scope.$watch(() => { return ngModel.$valid; }, (newValue) => {
                    validate(false);
                });

                // When the process editor save button is pressed. passing true for 'forceDirty'
                // ensures that the input field will be red and show the error message inside the popover
                scope.$on("validateConditionExpressions",() => {
                    validate(true);
                });
            }
        }
    }
    app.directive("conditionExpressionValidator", [conditionExpressionValidatorDirective]);

    interface ConditionExpressionValidatorScope extends ng.IScope{
        conditionExpressionValidator: string;
    }
}